import { FC } from 'react';
import { LegalPageContent } from '../components';
import { LegalProps } from '../legal.type';
import { LegalWrapper } from '../provider';

export const PrivacyPolicy: FC<LegalProps> = (props) => {
  return (
    <LegalWrapper {...props} documentType='privacy-policy'>
      <LegalPageContent />
    </LegalWrapper>
  );
};
